export default "__VITE_ASSET__BcUQZ9SB__"